import React from 'react';
import PeValuationUpdateContainer from './PeValuationUpdateContainer';

const RevenueInformationContainer = props => <PeValuationUpdateContainer hidePracticeInfo profileView {...props} />;

export default RevenueInformationContainer;
